
import React from 'react';
import { Outlet } from 'react-router-dom';
import { MaintenanceGuard } from '@/components/guards/MaintenanceGuard';

const OnboardingLayout = () => {
  return (
    <MaintenanceGuard>
      <div className="min-h-screen bg-black w-full">
        <main className="min-h-screen w-full">
          <Outlet />
        </main>
      </div>
    </MaintenanceGuard>
  );
};

export default OnboardingLayout;
